export default "__VITE_ASSET__69AcGMiI__"